import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import { stripTags } from "@/functions/stripTags";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import PropTypes from "prop-types";
import sourceflowEnums from "@/sourceflow.enums";

export const RecruitmentPageContentSection = ({ className, type, details }) => {
  const global = getGlobal();
  const locale = useLocale();
  const pathPrefix = `page.${type}.content`;

  if (type === null) {
    return null;
  }

  return (
    <SeriousAboutTalent
      className={className}
      tag={`${pathPrefix}.tag.${locale}`}
      title={`${pathPrefix}.title.${locale}`}
      text={`${pathPrefix}.text.${locale}`}
      details={details ? `${pathPrefix}.details.${locale}` : false}
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`${pathPrefix}.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal video_embed_url={stripTags(global[`${pathPrefix}.video.${locale}`]).trim()}>
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: `${pathPrefix}.image`,
                src: `/assets/${type}/content/1.jpg`,
              }}
              size="622x"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};

RecruitmentPageContentSection.defaultProps = {
  className: "py-4 py-md-5",
  type: null,
  details: false,
};

RecruitmentPageContentSection.propTypes = {
  type: PropTypes.oneOf(sourceflowEnums.config.recruitmentTypes.array),
};
